import { createRuntimeFn } from '@vanilla-extract/recipes/createRuntimeFn';

var content = 'fx_2d2fb1e5_doefz80';
var contentCommandRoot = 'fx_2d2fb1e5_doefz8a';
var contentScrollAreaViewport = 'fx_2d2fb1e5_doefz89';
var contentVariants = createRuntimeFn({defaultClassName:'fx_2d2fb1e5_doefz83',variantClassNames:{fitToTrigger:{true:'fx_2d2fb1e5_doefz84',false:'fx_2d2fb1e5_doefz85'},prefersReducedMotion:{reduce:'fx_2d2fb1e5_doefz86',noPreference:'fx_2d2fb1e5_doefz87'}},defaultVariants:{fitToTrigger:false,prefersReducedMotion:'noPreference'},compoundVariants:[]});

export { content, contentCommandRoot, contentScrollAreaViewport, contentVariants };
//# sourceMappingURL=content.vanilla.mjs.map
